<template>
  <div class="login-page">
    <div class="container h-100 d-flex flex-column justify-content-center">
      <div class="row justify-content-center">
        <div class="col-12 col-sm-10 col-md-8 col-lg-6">
          <div class="logo-container text-center mb-4">
            <img src="@/assets/TuitionWave.png" alt="Company Logo" class="img-fluid logo-img">
          </div>
          <div class="card shadow-lg p-3">
            <div class="card-body">
              <h4 class="card-title text-center mb-4 text-primary fw-bold">Login</h4>
              <form @submit.prevent="handleLogin">
                <div class="mb-3">
                  <label for="email" class="form-label text-secondary">Email address</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-envelope"></i></span>
                    <input
                      type="email"
                      class="form-control"
                      id="email"
                      v-model="email"
                      required
                      aria-label="Email address"
                      placeholder="Enter your email"  
                    />
                  </div>
                </div>
                <div class="mb-3">
                  <label for="password" class="form-label text-secondary">Password</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-key"></i></span>
                    <input
                      :type="showPassword ? 'text' : 'password'"
                      class="form-control"
                      id="password"
                      v-model="password"
                      required
                      aria-label="Password"
                      placeholder="Enter your password"
                    />
                    <button
                      class="btn btn-outline-primary"
                      type="button"
                      @click="togglePassword"
                      aria-label="Toggle password visibility"
                    >
                      <i :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                    </button>
                  </div>
                </div>
                <div class="d-grid gap-2 mt-4">
                  <button
                    type="submit"
                    class="btn btn-primary btn-block"
                    :disabled="loading"
                  >
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    <span v-if="!loading">Login</span>
                    <span v-else>Logging in...</span>
                  </button>
                </div>
              </form>

              <div v-if="message" class="mt-3 text-center" :class="messageClass">
                {{ message }}
              </div>
              <div v-if="$route.query.error" class="alert alert-danger mt-3 text-center">
                {{ $route.query.error }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer class="welcome-footer mt-5 text-center">
        <p>&copy; {{ currentYear }} MyTuitionWave.com | Powered by MySoftCode.com</p>
      </footer>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      currentYear: new Date().getFullYear(),
      email: '',
      password: '',
      showPassword: false,
      message: '',
      messageClass: '',
      loading: false, // New loading state
    };
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },

    // Helper: Wrap geolocation in a Promise
  getCurrentPosition() {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error('Geolocation is not supported by your browser'));
      } else {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        });
      }
    });
  },

  getDevice() {
    const ua = navigator.userAgent;

    if (/Windows/i.test(ua)) return 'Windows';
    if (/Macintosh|Mac OS X/i.test(ua)) return 'Mac';
    if (/iPhone/i.test(ua)) return 'iPhone';
    if (/Android/i.test(ua)) return 'Android';
    if (/Linux/i.test(ua)) return 'Linux';
    return 'Unknown';
  },

  getBrowser() {
    const ua = navigator.userAgent;

    if (ua.indexOf("Firefox") > -1) {
      return "Firefox";
    } else if (ua.indexOf("Opera") > -1 || ua.indexOf("OPR") > -1) {
      return "Opera";
    } else if (ua.indexOf("Trident") > -1) {
      return "Internet Explorer";
    } else if (ua.indexOf("Edge") > -1) {
      return "Edge";
    } else if (ua.indexOf("Chrome") > -1) {
      return "Chrome";
    } else if (ua.indexOf("Safari") > -1) {
      return "Safari";
    } else {
      return "Unknown";
    }
  },


  

    async handleLogin() {
  this.loading = true; // Set loading to true
  this.message = ''; // Clear any previous messages


  // Helper function: get approximate location fallback
  const getApproximateLocation = async () => {
    try {
      // Example with ipapi.co (free, no key required for basic)
      const res = await axios.get('https://ipapi.co/json/');
      const { latitude, longitude } = res.data;
      return {
        latitude: latitude || null,
        longitude: longitude || null,
        accuracy: null
      };
    } catch (err) {
      // If API call fails, fallback to timezone-based guess (very rough)
      // For demo, just return nulls
      return {
        latitude: null,
        longitude: null,
        accuracy: null
      };
    }
  };

  try {
    // const loginTime = new Date().toISOString(); // <-- add this line

    const now = new Date();
const loginTime = now.getFullYear() + '-' +
  String(now.getMonth() + 1).padStart(2, '0') + '-' +
  String(now.getDate()).padStart(2, '0') + ' ' +
  String(now.getHours()).padStart(2, '0') + ':' +
  String(now.getMinutes()).padStart(2, '0') + ':' +
  String(now.getSeconds()).padStart(2, '0');

    // 2. Get live GPS location
    // const position = await this.getCurrentPosition(); // This returns a Promise
    // const latitude = position.coords.latitude;
    // const longitude = position.coords.longitude;
    // const accuracy = position.coords.accuracy;


     let latitude, longitude, accuracy;

    try {
      // Try to get precise location
      const position = await this.getCurrentPosition();
      latitude = position.coords.latitude;
      longitude = position.coords.longitude;
      accuracy = position.coords.accuracy;
    } catch (geoError) {
      // User denied or error, fallback to approximate location
      const approx = await getApproximateLocation();
      latitude = approx.latitude;
      longitude = approx.longitude;
      accuracy = approx.accuracy;
    }

    const device = this.getDevice();
    const browser = this.getBrowser(); // newly added browser detection

      // NOTE: You cannot get IP address reliably on frontend without external service.
      // So you send null or empty, and your backend should get IP from request

    const response = await axios.post('/userlogin', {
      email: this.email,
      password: this.password,
      login_time: loginTime, // <-- send login_time
      latitude: latitude,
      longitude: longitude,
      accuracy: accuracy,
      device: device,
      browser: browser,
    });

    if (response && response.data) {
      const { token, firstName, profile_photo_url, role, id, teacher_id, institute_id,  theme_color } = response.data;

      // Store common values in localStorage
      localStorage.setItem('token', token);
      localStorage.setItem('firstName', firstName);
      localStorage.setItem('profile_photo_url', profile_photo_url);
      localStorage.setItem('role', role);
      localStorage.setItem('id', id);
      localStorage.setItem('themeMode', theme_color); 
      

      // Store role-specific values in localStorage
      if (role === 1) {
        localStorage.setItem('teacher_id', teacher_id);
      } else if (role === 2) {
        localStorage.setItem('institute_id', institute_id);
      }

      this.message = 'Login successful!';
      this.messageClass = 'text-success';

      // Navigate based on role
      if (role === 1) {
        // this.$router.push('/teacherHome');
        this.$router.push({ path: "/teacherHome", query: { currentPage: "home" } });
      } else if (role === 2) {
        // this.$router.push('/instituteHome');
        this.$router.push({ path: "/instituteHome", query: { currentPage: "home" } });
      } else {
        this.message = 'Unauthorized role!';
        this.messageClass = 'text-danger';
      }
    } else {
      this.message = 'Unexpected response structure';
      this.messageClass = 'text-danger';
    }
  } catch (error) {
    console.error('Login error:', error);

    if (error.response) {
      this.message = 'Login failed: ' + (error.response.data.message || 'Unknown error');
    } else if (error.request) {
      this.message = 'Login failed: No response from server';
    } else {
      this.message = 'Login failed: ' + error.message;
    }

    this.messageClass = 'text-danger';
  } finally {
    this.loading = false; // Reset loading state
  }
},

  },

  mounted() {
  const errorQuery = this.$route.query.error;
  if (errorQuery === 'unauthorized') {
    this.message = 'You have been logged out or your session expired.';
    this.messageClass = 'text-danger';
  }
}

};
</script>

<style scoped>
.login-page {
  position: relative; /* Needed for absolute positioning of the footer */
  min-height: 100vh; /* Ensures the page takes at least the full viewport height */
  background-color: #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 60px; /* Add padding at the bottom equal to footer height */
  box-sizing: border-box; /* Include padding in the element's total width and height */
}

/* Adjust container to allow content to flow above the footer */
.container {
  flex-grow: 1; /* Allows the container to grow and push footer down */
  padding-bottom: 20px; /* Add some space between card and footer if not using absolute positioning for footer */
}

/* If you're using Bootstrap's container and not making the whole page a flex item,
   you might need to adjust the main app layout or use a wrapper div for the content
   to ensure the footer stays at the bottom when content is short.
   The `min-height: 100vh` on `.login-page` and `padding-bottom` on `.login-page`
   along with `position: absolute` for the footer is generally the most robust approach.
*/

.logo-img {
  max-width: 150px; /* Slightly larger logo for better visibility */
}

.card {
  border: none;
  border-radius: 15px; /* Softer, more modern corners */
}

.card-title {
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.input-group-text {
  background-color: #fff;
  border-right: none;
  border-color: #ced4da;
  color: #6c757d;
}

.form-control:focus {
  box-shadow: 0 0 0 0.25rem rgba(0, 123, 255, 0.25);
  border-color: #007bff;
}

.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
  transition: all 0.3s ease; /* Add transition for a smoother hover effect */
}

.btn-primary:hover {
  background-color: #0056b3;
  border-color: #004085;
  transform: translateY(-2px); /* Subtle lift on hover */
}

.btn-outline-primary {
  color: #007bff;
  border-color: #007bff;
  transition: all 0.3s ease;
}

.btn-outline-primary:hover {
  background-color: #007bff;
  color: #fff;
}

.welcome-footer {
  position: absolute; /* Positions the footer relative to the nearest positioned ancestor */
  bottom: 0;         /* Aligns the footer to the bottom */
  left: 0;
  right: 0;
  width: 100%;       /* Makes the footer span the full width */
  background-color: #f8f9fa; /* A light background for the footer */
  padding: 15px 0;   /* Vertical padding for spacing */
  color: #6c757d;
  font-size: 0.8rem;
  text-align: center;
  box-shadow: 0 -2px 5px rgba(0,0,0,0.05); /* Subtle shadow to lift it */
}
</style>